export default __webpack_public_path__ + "static/media/ic_curacao.49982230.svg";